export default "__VITE_ASSET__Cg4B0ur7__"